import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Avatar from '@mui/material/Avatar';
import { SxProps } from '@mui/material/styles';

import { THUMBNAIL_SIZES, useApiDownloadImage } from 'api/queries';
import { Sxable } from 'library/types';

export interface UnitAvatarProps extends Sxable {
	imageId?: number | null;
	thumbnail?: boolean;
	withZoom?: boolean;
}

const zoomSx: SxProps = {
	transition: 'transform .125s linear',
	'&:hover': {
		transform: 'scale(1.2)',
	},
};

export const UnitAvatar = ({
	imageId,
	sx = [],
	thumbnail = false,
	withZoom = false,
}: UnitAvatarProps): React.JSX.Element => {
	const source = useApiDownloadImage(
		imageId,
		thumbnail ? THUMBNAIL_SIZES.SMALL : undefined
	);

	return (
		<Avatar
			className="unit-avatar__root"
			src={source}
			alt={imageId?.toString()}
			slotProps={{
				img: {
					sx: withZoom && imageId ? zoomSx : {},
				},
			}}
			sx={[
				{
					bgcolor: 'grey.300',
					width: source ? 'auto' : undefined,
					objectFit: 'contain',
				},
				...(Array.isArray(sx) ? sx : [sx]),
			]}
			variant="square">
			<PhotoCamera />
		</Avatar>
	);
};
